<!-- バックヤード > パスワードを忘れた方 -->
<template>
  <v-container
    fluid
    fill-height
  >
    <v-card
      v-if="user"
      outlined
      class="mx-auto"
      style="width: 40rem;"
    >
      <v-card-title
        class="justify-center"
      >
        <h3
          class="text-center"
        >
          パスワードの変更
        </h3>
      </v-card-title>
      <v-card-subtitle>
        パスワードの再設定を行います。他人に推測されやすいものは避けてください。
      </v-card-subtitle>
      <v-card-text>
        <div>
          <alert-message />
        </div>

        <validation-observer ref="driverForgetFormValidator">
          <v-form class="mt-5">
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  vid="password"
                  rules="required|password"
                  name="パスワード"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :error-messages="errors"
                    :type="showPassword ? 'text' : 'password'"
                    label="パスワード"
                    hide-details="auto"
                    persistent-placeholder
                    @click:append="showPassword = !showPassword"
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  vid="confirmation"
                  rules="required|confirmed:password"
                  name="パスワード(確認用)"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="password_confirmation"
                    :append-icon="showConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :error-messages="errors"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    hide-details="auto"
                    label="パスワード(確認用)"
                    persistent-placeholder
                    @click:append="showConfirmPassword = !showConfirmPassword"
                  />
                </validation-provider>
              </v-col>
            </v-row>

            <v-spacer class="clearfix mb-5" />
            <v-row
              align="center"
              justify="center"
              class="fill-height"
            >
              <v-card outlined>
                <v-card-text>
                  <div class="subtitle-2">
                    半角8~12文字 英小文字・大文字・数字をそれぞれ1種類以上
                  </div>
                </v-card-text>
              </v-card>
            </v-row>

            <v-spacer class="clearfix mb-5" />

            <v-btn
              v-if="user.role != 'driver_user'"
              @click="cancelButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              class="float-right"
              @click="registerButtonClickEvent"
            >
              変更
            </v-btn>
          </v-form>
        </validation-observer>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
  import AlertMessage from "../../../components/AlertMessage";
  import { mapActions } from 'vuex'
  export default {
    name: 'ForgetEdit',
    components: {
      AlertMessage
    },
    mixins: [
    ],
    data () {
      return {
        password: null,
        password_confirmation: null,
        token: null,
        showPassword: false,
        showConfirmPassword: false,
        user: null
      }
    },
    created () {
      this.editUser({ token: this.$route.params.token }).then((content) => {
        if(content.status){
          this.user = content.user
        }else{
          this.$router.replace('notfound')
        }
      })
    },
    methods: {
      ...mapActions('DriverForget', {
        resetPassword: 'update'
      }),
      ...mapActions('DriverForget', {
        editUser: 'edit',
      }),
      cancelButtonClickEvent () {
        this.$router.push({name: 'DriverSessions'})
      },
      registerButtonClickEvent () {
        let $self = this
        this.$refs.driverForgetFormValidator.validate().then((result) => {
          if (result) {
            $self.sendRegistrationInformation()
          }
        })
      },
      sendRegistrationInformation () {
        let params = {
          password: this.password,
          password_confirmation: this.password_confirmation
        }
        this.resetPassword( { token: this.$route.params.token, params: params }).then((content) => {
          if(content.status){
            if (this.user.role === 'driver_user') {
              this.$router.push({name: 'DriverForgetCompleted', query: {sp: null}})
            } else {
              this.$router.push({name: 'DriverForgetCompleted'})
            }
          } else {
            this.$router.replace("notfound")
          }
        })
      },
    }
  }
</script>

<style lang="scss">
</style>
